export const SALESFORCE_CLIENT_NAME = 'Salesforce';
export const SALESFORCE_ACCESS_TOKEN_KEY = 'sfAccessToken';
export const SALESFORCE_ACCESS_TOKEN_EXPIRATION = 'sfAccessTokenExpiration';
export const CLIENT_HOUSEHOLD_RECORD_TYPE_ID = '0128c000001x6BRAAY';
export const PROSPECT_RECORD_TYPE_ID = '0128c000001x6BPAAY';
